var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container d-flex justify-content-center"},[_c('b-col',{attrs:{"md":"8","cols":"12"}},[_c('step-progress',{attrs:{"steps":_vm.mySteps,"current-step":_vm.step,"active-thickness":1,"passive-thickness":1,"line-thickness":4}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }